<div class="bg-white p-1 p-md-4 payment-info">
  <div class="text-center mt-4">
    <img src="/img/icos/trash.svg" alt="" style="max-width: 40%" width="100" class="img-fluid img-cover" />
  </div>
  <h3 class="text-center font-weight-bold mt-4">
    <span [innerHTML]="'web.account_delete_title' | translate | markdown" class="emph-text-dashboard"></span>
  </h3>
  <div class="text-center mt-5">
    {{ 'web.account_delete_text' | translate }}
  </div>
  @if (deleteFailed) {
    <div class="text-center mt-5 alert-color">
      {{ 'web.account_delete_failed' | translate }}
    </div>
  }
  @if (deleteSuccess) {
    <div class="text-center mt-5 alert-success">
      {{ 'web.account_delete_success' | translate }}
    </div>
  }
  <div class="text-center mt-5">
    <button (click)="delete()" class="--button">{{ 'web.delete_account' | translate }}</button>
  </div>
</div>
